module.exports = __webpack_public_path__ + "img/a2.6a0e1ac8.jpg";